module.exports = __webpack_public_path__ + "img/success.2e3cb13d.png";